export const GOOGLE_CLASSROOM_API_BASE_URL =
  'https://classroom.googleapis.com/v1';
export const GOOGLE_CLASSROOM_LANDING_PAGE_TYPE_PARAM_KEY =
  'gc_landingPageType';
